const RightIcon = () => {
  return (
    // <svg
    //   version="1.1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   xmlnsXlink="http://www.w3.org/1999/xlink"
    //   x="0px"
    //   y="0px"
    //   viewBox="0 0 503 503"
    //   xmlSpace="preserve"
    // >
    //   <g>
    //     <path
    //       d="M500.803,246.062L295.832,41.09c-4.438-4.438-10.34-6.883-16.617-6.883s-12.178,2.445-16.617,6.883l-33.943,33.942
    // c-4.438,4.438-6.883,10.34-6.883,16.617c0,6.277,2.445,12.179,6.883,16.617l95.598,95.598H23.5c-12.958,0-23.5,10.542-23.5,23.5v48
    // c0,12.958,10.542,23.5,23.5,23.5h300.813l-95.44,95.896c-9.119,9.163-9.101,24.054,0.04,33.194l33.955,33.955
    // c4.439,4.439,10.339,6.883,16.617,6.883c0.005,0,0.011,0,0.016,0c6.283-0.004,12.187-2.457,16.624-6.905l204.687-205.226
    // C503.732,253.731,503.729,248.988,500.803,246.062z M285.504,451.295c-1.605,1.609-3.741,2.496-6.013,2.498
    // c-2.248,0.01-4.409-0.883-6.016-2.49l-33.955-33.955c-3.307-3.306-3.313-8.692-0.015-12.006l108.17-108.687
    // c2.138-2.148,2.773-5.371,1.61-8.169c-1.163-2.798-3.896-4.622-6.926-4.622H23.5c-4.687,0-8.5-3.813-8.5-8.5v-48
    // c0-4.687,3.813-8.5,8.5-8.5h318.859c3.034,0,5.768-1.827,6.929-4.63c1.161-2.802,0.519-6.028-1.626-8.173L239.262,97.66
    // c-1.605-1.605-2.49-3.74-2.49-6.01s0.884-4.405,2.49-6.01l33.943-33.943c1.605-1.605,3.74-2.49,6.01-2.49s4.405,0.884,6.011,2.49
    // L484.9,251.372L285.504,451.295z"
    //     />
    //     <path
    //       d="M423.513,274.852c1.919,0,3.839-0.732,5.303-2.196l15.987-15.987c2.929-2.929,2.929-7.678,0-10.606
    // c-2.929-2.93-7.678-2.93-10.606,0l-15.987,15.987c-2.929,2.929-2.929,7.677,0,10.606
    // C419.674,274.12,421.593,274.852,423.513,274.852z"
    //     />
    //     <path
    //       d="M330.197,360.668c1.464,1.464,3.384,2.196,5.303,2.196s3.839-0.732,5.303-2.196l64.001-64.002
    // c2.929-2.929,2.929-7.677,0-10.606c-2.929-2.929-7.678-2.929-10.606,0l-64.001,64.002
    // C327.268,352.991,327.268,357.739,330.197,360.668z"
    //     />
    //     <path
    //       d="M151.5,243.865h-104c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h104c4.142,0,7.5-3.357,7.5-7.5
    // C159,247.223,155.642,243.865,151.5,243.865z"
    //     />
    //     <path
    //       d="M207.5,243.865h-24c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h24c4.142,0,7.5-3.357,7.5-7.5
    // C215,247.223,211.642,243.865,207.5,243.865z"
    //     />
    //   </g>
    // </svg>
    <svg
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="48"
        height="48"
        fill="white"
        stroke="none"
        fillOpacity="0.01"
      />
      <path
        d="M34 24.0083H6"
        // stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12L34 24L22 36"
        // stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 12V36"
        // stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RightIcon;
